"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_pixi_1 = require("@inlet/react-pixi");
var pixi_js_1 = require("pixi.js");
exports.CanvasAlignmentHighlighter = react_pixi_1.PixiComponent("CanvasAlignmentHighlighter", {
  create: function create(props) {
    var toReturn = new pixi_js_1.Graphics();
    toReturn.interactive = true;
    return toReturn;
  },
  applyProps: function applyProps(instance, oldProps, newProps) {
    var x = newProps.x,
      y = newProps.y,
      width = newProps.width,
      height = newProps.height,
      fillColor = newProps.fillColor,
      fillAlpha = newProps.fillAlpha;
    instance.clear();
    instance.beginFill(fillColor, fillAlpha);
    instance.drawRect(x, y, width, height);
    instance.endFill();
    //inspired by
    //http://scottmcdonnell.github.io/pixi-examples/index.html?s=demos&f=dragging.js
    if (oldProps.dragFunctions !== newProps.dragFunctions) {
      instance.removeAllListeners();
      if (newProps.dragFunctions) {
        instance.addListener("pointerdown", function (e) {
          e.stopPropagation(); //keep entire viewport from moving
        });
        var dragStart = function dragStart(e) {
          var _a;
          (_a = newProps.dragFunctions) === null || _a === void 0 ? void 0 : _a.onDragStart(e, instance.parent);
        };
        var dragEnd = function dragEnd(e) {
          var _a;
          (_a = newProps.dragFunctions) === null || _a === void 0 ? void 0 : _a.onDragEnd(e, instance.parent);
        };
        var dragMove = function dragMove(e) {
          var _a;
          (_a = newProps.dragFunctions) === null || _a === void 0 ? void 0 : _a.onDragMove(e, instance.parent);
        };
        //events for drag start
        instance.addListener("mousedown", dragStart);
        instance.addListener("touchstart", dragStart);
        // events for drag end
        instance.addListener("mouseup", dragEnd);
        instance.addListener("mouseupoutside", dragEnd);
        instance.addListener("touchend", dragEnd);
        instance.addListener("touchendoutside", dragEnd);
        // events for drag move
        instance.addListener("mousemove", dragMove);
        instance.addListener("touchmove", dragMove);
      }
    }
  }
});